/**
 * 개인정보 처리방침 (Privacy Policy) - 한국어 v2
 * 
 * 시행일: 2026년 2월 1일
 */
export const PRIVACY_V2_KO = {
    version: "v2",
    effectiveDate: "2026-02-01",
    language: "ko",
    title: "개인정보 처리방침",
    content: `
Spot Go 개인정보 처리방침

최종 업데이트: 2026년 2월 1일 (KST)

본 개인정보 처리방침은 Spot Go 개발자("개발자", "당사", "우리")가 귀하가 당사의 서비스 Spot Go("서비스")를 이용할 때 귀하의 정보를 어떻게 수집, 이용, 공개하는지 설명합니다.

1. 수집하는 정보

당사는 서비스 운영 및 개선에 필요한 데이터만 수집하고 저장합니다.

1.1 Pi Network 계정 정보

귀하가 서비스에 로그인할 때 고유한 Pi Network 사용자 ID와 닉네임을 수신합니다. Pi Network 비밀번호는 수신하거나 저장하지 않습니다.

1.2 이용 데이터

계정 관리, 리더보드 랭킹, 이용 기록 목적으로 닉네임과 사용자 ID를 서버에 저장합니다.

1.3 배송 정보 (선택)

상품 배송이 필요한 경우 귀하가 직접 입력한 배송지 정보(이름, 주소, 연락처)를 수집합니다. 이 정보는 배송 목적으로만 사용됩니다.

1.4 게시물 정보

귀하가 등록한 게시물(스팟)의 내용, 이미지, 위치 정보를 저장합니다.

2. 정보 이용 방법

• 서비스 제공 및 유지
• 계정 관리 및 이용 기록 저장
• 상품 배송 (해당 시)
• 서비스 보안과 무결성 보호

2-1. 닉네임의 공개 표시

랭킹 및 커뮤니티 기능을 제공하기 위해 귀하의 Pi Network 닉네임은 서비스 내 다른 사용자에게 공개적으로 표시될 수 있습니다(예: 리더보드, 게시물).

3. 정보 공유

당사는 개인 정보를 판매하거나 임대하지 않습니다. 아래 경우에만 정보를 공유할 수 있습니다:

• 서비스 제공업체: Firebase(데이터 저장), Cloudflare(이미지 저장)
• 법적 사유: 법률에서 요구하는 경우 또는 권리 보호를 위해 정보를 공개할 수 있습니다

4. 데이터 삭제

lukep81@painori.com으로 "데이터 삭제 요청" 제목으로 이메일을 보내 데이터 삭제를 요청할 수 있습니다. 처리 시 모든 데이터가 영구적으로 삭제됩니다.

5. 데이터 보안

합리적인 기술적 조치를 사용하여 귀하의 데이터를 보호하지만, 인터넷을 통한 전송 방법은 100% 안전하지 않습니다.

6. 국제 데이터 전송

귀하의 데이터는 귀하의 국가 외부의 서버(Google Firebase, Cloudflare)로 전송되어 저장될 수 있습니다. 서비스를 이용함으로써 귀하는 이러한 전송에 동의합니다.

7. 아동의 개인정보

당사 서비스는 만 14세 미만의 아동을 대상으로 하지 않습니다. 아동의 데이터를 고의로 수집하지 않습니다. 그러한 데이터를 수집했음을 알게 되면 즉시 삭제합니다.

8. 문의하기

본 개인정보 처리방침에 대한 질문이 있으시면 다음으로 연락해 주세요: lukep81@painori.com
`.trim()
};
